import * as React from "reactn";
import Constants from "../util/Constants";
import {BaseIcon, ComponentFactory, Route} from "oca-lib-web";
import logo from '../image/analytics_logo_large.png'
import Styles from "../style/Styles";

interface IProps {
    onSelect:(index:any) => void
}

interface IState {
    componentFactory:ComponentFactory,
    open: boolean
}

class Sidebar extends React.Component<IProps, IState> {

    constructor(props: any) {
        super();

        this.state = {
            componentFactory:new ComponentFactory(Styles.default),
            open: true
        }
    }

    render() {
        const cf = this.state.componentFactory;
        return (
            cf.renderDrawer("permanent", this.state.open, "left",
                cf.renderBoxProps({backgroundColor:Constants.WHITE_COLOR, center:true, height:'100vh'}, [
                    cf.renderBoxProps({marginLeft:"20px", marginRight:"20px", marginTop:"20px", marginBottom:"30px"},
                        <img src={logo} width={30} className="center-img" />
                    ),
                    cf.renderBoxProps({marginTop:'20px'}, cf.renderIconButton(BaseIcon.ICON_ANALYTICS, () => Route.go(this, "dashboard"))),
                    cf.renderBoxProps({marginTop:'20px'}, cf.renderIconButton(BaseIcon.ICON_CHAT_BUBBLE, () => Route.go(this, "messaging"))),
                    cf.renderBoxProps({marginTop:'20px'}, cf.renderIconButton(BaseIcon.ICON_SETTINGS, () => Route.go(this, "admin"))),
                    cf.renderBoxProps({bottom:true, marginLeft:'10px'}, cf.renderIconButton(BaseIcon.ICON_PROFILE, () => Route.go(this, "profile"))),
                ])
            )
        )
    }
}

export default Sidebar